module.exports = __webpack_public_path__ + "static/media/fl-mk.46961e9a.png";